export { default } from './Tinder'
